export enum TipoUsuario {
  Normal,
  Admin,
  IziiAdmin,
}
